import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import college from "../config/collegeConfig";
import { apiJson } from "../utils/api";
import { useT, LanguageToggle } from "../i18n/LanguageContext";

const StudentLogin = () => {
  const { t } = useT();
  const [regNo, setRegNo] = useState("");
  const [dob, setDob] = useState("");
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setMessage("");

    try {
      const data = await apiJson("/api/login", {
        method: "POST",
        body: JSON.stringify({ applyId: regNo, dateOfBirth: dob }),
      });

      localStorage.setItem("token", data.token);
      localStorage.setItem("student", JSON.stringify(data.student));
      navigate("/student");
    } catch (err) {
      setMessage(err.message || "Login error. Please try again.");
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col items-center justify-center px-4 relative">
      <div className="absolute top-4 right-4"><LanguageToggle /></div>
      <div className="text-center mb-8">
        {college.logo && (
          <img
            src={college.logo}
            alt="College Logo"
            className="mx-auto mb-2 w-20 h-20 object-contain"
          />
        )}
        <h1 className="text-xl sm:text-2xl font-bold text-gray-800">
          {college.name}
        </h1>
        <p className="text-sm text-gray-500">{college.tagline}</p>
      </div>

      <div className="w-full max-w-md bg-white shadow-md rounded-lg p-6">
        <h2 className="text-lg font-semibold text-gray-700 text-center mb-4">
          {t("auth.studentLogin")}
        </h2>
        <form onSubmit={handleLogin} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">
              {t("auth.applyId")}
            </label>
            <input
              type="text"
              value={regNo}
              onChange={(e) => setRegNo(e.target.value)}
              required
              className="mt-1 block w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring focus:ring-indigo-200"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              {t("auth.dateOfBirth")}
            </label>
            <input
              type="date"
              value={dob}
              onChange={(e) => setDob(e.target.value)}
              required
              className="mt-1 block w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring focus:ring-indigo-200"
            />
          </div>

          <button
            type="submit"
            className="w-full bg-indigo-600 text-white py-2 rounded-md hover:bg-indigo-700 transition"
          >
            {t("common.login")}
          </button>
        </form>

        {message && (
          <p className="text-red-600 text-sm mt-4 text-center">{message}</p>
        )}

        <p className="text-sm text-gray-500 text-center mt-4">
          <Link to="/register" className="text-indigo-600 hover:underline">{t("common.register")}</Link>
        </p>
      </div>
    </div>
  );
};

export default StudentLogin;
